import { ITypedReduxAction } from '../../types/redux/actionType';
import { IMarkedList } from '../../types/seo';
import { ISeoPageData } from '../../types/seo/pageData';

export enum ESeoActionType {
  SetPageData = 'Seo/SetPageData',
  SetMarkedList = 'Seo/SetMarkedList',
}

export type TSeoAction = TSetPageDataAction | TSetMarkedListAction;

export type TSetPageDataAction = ITypedReduxAction<ESeoActionType.SetPageData, ISeoPageData | null>;

export type TSetMarkedListAction = ITypedReduxAction<ESeoActionType.SetMarkedList, IMarkedList | null>;
